import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({ providedIn: 'root' })
export class TransferenciaOrquestradorService extends CommonService {
  private readonly apiUrl: string = environment.urlApiOrquestradorSuprimentos + 'TransferenciaOrquestrador';

  constructor(private httpClient: HttpClient) {
    super();
  }

  public processar(idTransferenciaEstoque: number): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(`${this.apiUrl}/idTransferenciaEstoque/${idTransferenciaEstoque}/processar`, {}, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  // Único caminho de exclusão independente do status — quem decide Pendente/Concluída/bloqueio
  // é o backend (Suprimentos decide, Orquestrador só orquestra o estorno no Produto quando preciso).
  public excluir(idTransferenciaEstoque: number): Observable<ReturnStruct> {
    return this.httpClient
      .delete<ReturnStruct>(`${this.apiUrl}/idTransferenciaEstoque/${idTransferenciaEstoque}`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
